

export function checkIsNotUndefined<T>(value: T | undefined): value is T {
  return value !== undefined;
}
